export { default as useInjectStore } from './use-inject-store.hook'
